"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "loreto": {
    "00abd6b3": [{
      "hkey": "9d8418cb",
      "slug": "costabianca",
      "name": "Costabianca",
      "primary": true,
      "skipSearch": false
    }],
    "costabianca-e-grotte": [{
      "hkey": "9d8418cb",
      "slug": "costabianca",
      "name": "Costabianca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a7f8362": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "skipSearch": false
    }],
    "il-pozzo": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "254a99c7": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "skipSearch": false
    }],
    "la-costa": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9dc42d59": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "skipSearch": false
    }],
    "la-piana-e-montereale": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc8b5bea": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-le-mura": [{
      "hkey": "8251f14b",
      "slug": "loreto",
      "name": "Loreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "078452d1": [{
      "hkey": "128b32e6",
      "slug": "loreto-stazione",
      "name": "Loreto Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "stazione-e-villa-berghigna": [{
      "hkey": "128b32e6",
      "slug": "loreto-stazione",
      "name": "Loreto Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1e870d35": [{
      "hkey": "30d393b1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villa-costantina": [{
      "hkey": "30d393b1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "loreto"
    }]
  }
};
exports["default"] = _default;